import { BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { CheckOutAvailableItem, CheckOutDetail, CheckOutItem, CheckOutItemDetail, ServiceCharge } from './../../interfaces/check_out';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { DatePipe } from '@angular/common'
import { PetDetail } from 'src/app/interfaces/pet';
import { PetService } from 'src/app/services/pet.service';
import { Service } from './../../interfaces/check_in';
import { Subject } from 'rxjs';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { logFormData } from 'src/app/utils/form-util';
import { InvoiceDetail } from '../../interfaces/invoice';
import { DataMappingService } from '../../services/data-mapping.service';

@Component({
  selector: 'app-check-out-detail',
  templateUrl: './check-out-detail.component.html',
  styleUrls: ['./check-out-detail.component.scss']
})
export class CheckOutDetailComponent implements OnInit {
  modalRef: BsModalRef;
  selectedCheckOut= {} as CheckOutDetail;
  title?: string;
  closeBtnName?: string;
  isNew = false;
  checkOutDetailForm: FormGroup;
  checkOutDetailData = new FormData();
  isServicesLoaded = false;
  services = [] as Service[];
  selectedServices = [] as Service[];
  selectedService = {} as Service;
  selectedServiceCharges = [] as ServiceCharge[];
  selectedServiceCharge = {} as ServiceCharge;
  isSavingCheckOut = false;
  availableItems = [] as CheckOutAvailableItem[];
  selectedAvailableItem = {} as CheckOutAvailableItem;
  selectedAvailableItems = [] as CheckOutAvailableItem[];
  selectedItem = {} as CheckOutItemDetail;
  selectedItems = [] as CheckOutItemDetail[];
  isAvailableItemsLoaded = false;
  checkOutItems = [] as CheckOutItemDetail[];
  selectedCheckOutItem = {} as CheckOutItemDetail;
  checkOutPets = [] as PetDetail[];
  selectedPet = {} as PetDetail;
  createInvoiceData = new FormData();
  isCreatingInvoice = false;
  discount = 0;
  totalAmount = 0;
  subTotalAmount = 0;
  hasEditPermission: boolean = false;
  hasAddPermission: boolean = false;
  hasAddInvoicePermission: boolean = false;
  isLoadingCheckOutInvoice = false;
  checkOutInvoice = {} as InvoiceDetail;

  public onClose= new Subject<boolean>();

  constructor(
    private petService: PetService,
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    public datepipe: DatePipe,
    private dataMappingService: DataMappingService,
  ) {
    this.checkOutDetailForm = this.formBuilder.group({
      date: '',
      petName: '',
      itemName: '',
      unitPrice: '',
      quantity: '',
      discount: [0, { nonNullable: true }]
    });

    // Subscribe to value changes
    this.checkOutDetailForm.get('discount')?.valueChanges.subscribe(newValue => {
      this.onDiscountChanged(newValue);
    });

    this.modalRef = bsModalRef;
  }

  ngOnInit(): void {
    // this.getServices();
    this.checkPermissions();
    this.getAvailableItems();
    console.log(`check-out-detail, ngOnInit, isNew: ${JSON.stringify(this.isNew)}`);
    if (!this.isNew) {
      console.log(`check-in-detail, ngOnInit, selectedCheckOut: ${JSON.stringify(this.selectedCheckOut)}`);
      this.patchCheckOutDetailForm(this.selectedCheckOut);
      console.log(`check-in-detail, ngOnInit, items: ${JSON.stringify(this.selectedCheckOut.items)}`);
      this.checkOutItems = this.selectedCheckOut.items;
      this.calculateSubtotal();
      this.onDiscountChanged(Number(this.selectedCheckOut.discount));
      this.checkOutPets = this.selectedCheckOut.checkIn.pets;
      this.getCheckOutInvoice();
    }

    if (!this.hasEditPermission) {
      this.disableForm();
    }
  } // end of ngOnInit

  getAvailableItems() {
    this.isAvailableItemsLoaded = false;
    this.petService.getCheckOutAvailableItems().subscribe({
      next: (response) => {
        console.log(`getAvailableItems, response: ${JSON.stringify(response)}`);
        this.availableItems = response;
        this.isAvailableItemsLoaded = true;
      },
      error: (error) => {
        this.isAvailableItemsLoaded = true;
        console.error(`getAvailableItems, error: ${JSON.stringify(error)}`);
      }
    });
  } // end of getAvailableItems

  onSelectItem (event: TypeaheadMatch): void{
    this.selectedAvailableItem = event.item;
    this.selectedItem.itemId = this.selectedAvailableItem.id;
    this.selectedItem.itemType = this.selectedAvailableItem.type;
    this.selectedItem.itemName = this.selectedAvailableItem.name;
    console.log(`onSelectItem, selectedItem:${JSON.stringify(this.selectedAvailableItem)}`);
    this.selectedAvailableItems.push(this.selectedAvailableItem);
  } // end of onSelectItem

  onSelectPet (event: TypeaheadMatch): void{
    this.selectedPet = event.item;
    console.log(`onSelectPet, selectedPet:${JSON.stringify(this.selectedPet)}`);
  } // end of onSelectPet

  getServices() {
    this.isServicesLoaded = false;
    this.petService.getServices().subscribe({
      next: (response) => {
        console.log(`getServices, response: ${JSON.stringify(response)}`);
        this.services = response;
        this.isServicesLoaded = true;
      },
      error: (error) => {
        this.isServicesLoaded = true;
        console.error(`getServices, error: ${JSON.stringify(error)}`);
      }
    });
  } // end of getServices

  onSelectService (event: TypeaheadMatch): void{
    this.selectedService = event.item;
    console.log(`onSelectService, selectedService:${this.selectedService.name}`);
    this.selectedServices.push(this.selectedService);
  } // end of onSelectService

  editServiceCharge(serviceCharge: ServiceCharge) {
    console.log(`editServiceCharge, serviceCharge: ${JSON.stringify(serviceCharge)}`);
    this.selectedServiceCharge = serviceCharge;
    this.selectedService = serviceCharge.service;
    this.checkOutDetailForm.patchValue({
      serviceName: serviceCharge.service.name,
      amount: Number(serviceCharge.chargeAmount)?? 0,
      discount: serviceCharge.discount?? 0
    });
  } // end of editServiceCharge

  saveServiceCharge() {
    console.log(`saveServiceCharge`);
    if (this.selectedServiceCharge.id) {
      this.updateServiceChargesList()
    } else {
      this.addServiceChargesList();
    }
    // Clear selected service charge
    this.selectedServiceCharge = {} as ServiceCharge;
    // Clear the service charge form
    this.clearServiceChargeForm();
  } // end of saveServiceCharge

  editCheckOutItem(checkOutItem: CheckOutItemDetail) {
    console.log(`editCheckOutItem, checkOutItem: ${JSON.stringify(checkOutItem)}`);
    this.selectedCheckOutItem = checkOutItem;
    this.selectedPet = checkOutItem.pet;
    // this.selectedItem = checkOutItem;
    console.log(`editCheckOutItem, selectedCheckOutItem: ${JSON.stringify(this.selectedCheckOutItem)}`);
    this.checkOutDetailForm.patchValue({
      petName: checkOutItem.pet.name,
      itemName: checkOutItem.itemName,
      unitPrice: Number(checkOutItem.unitPrice)?? 0,
      quantity: checkOutItem.quantity?? 1
    });
  } // end of editCheckOutItem

  removeCheckOutItem(checkOutItem: CheckOutItemDetail) {
    console.log(`removeCheckOutItem, checkOutItem: ${JSON.stringify(checkOutItem)}`);
  }  // end of removeCheckOutItem

  saveCheckOutItem() {
    console.log(`saveCheckOutItem`);
    console.log(`saveCheckOutItem, this.selectedCheckOutItem: ${JSON.stringify(this.selectedCheckOutItem)}`);
    if (this.selectedCheckOutItem.itemId) {
      this.updateCheckOutItemsList()
    } else {
      this.addCheckOutItemList();
    }
    // Clear selected item
    this.selectedCheckOutItem = {} as CheckOutItemDetail;

    // Clear the service charge form
    this.clearServiceChargeForm();
  } // end of saveCheckOutItem

  getServiceChargeDetailFromForm(): ServiceCharge {
    let amount = this.checkOutDetailForm.controls['amount'].value;
    let discount = this.checkOutDetailForm.controls['discount'].value;
    console.log(`getServiceChargeDetailFromForm, selectedService: ${JSON.stringify(this.selectedService)}`);
    console.log(`getServiceChargeDetailFromForm, amount: ${amount}, discount: ${discount}`);
    let serviceCharge= {} as ServiceCharge;
    serviceCharge.service = this.selectedService;
    serviceCharge.chargeAmount= amount;
    serviceCharge.discount = discount;
    console.log(`getServiceChargeDetailFromForm, serviceCharge: ${JSON.stringify(serviceCharge)}`);
    return serviceCharge;
  } // end of getServiceChargeDetailFromForm

  getItemDetailFromForm(): CheckOutItemDetail {
    let petName = this.checkOutDetailForm.controls['petName'].value;
    console.log(`getItemDetailFromForm, petName: ${JSON.stringify(petName)}`);
    let itemName = this.checkOutDetailForm.controls['itemName'].value;
    let unitPrice = this.checkOutDetailForm.controls['unitPrice'].value;
    let quantity = this.checkOutDetailForm.controls['quantity'].value;

    console.log(`getItemDetailFromForm, selectedService: ${JSON.stringify(this.selectedItem)}`);
    console.log(`getItemDetailFromForm, quantity: ${quantity}, quantity: ${quantity}`);
    let checkOutItem = {} as CheckOutItemDetail;
    checkOutItem.itemId = this.selectedItem.itemId;
    checkOutItem.itemType = this.selectedItem.itemType;
    if (this.selectedCheckOutItem.itemId) {
      checkOutItem.itemId = this.selectedCheckOutItem.itemId;
      checkOutItem.itemType = this.selectedCheckOutItem.itemType;
    }
    // checkOutItem.itemId = this..itemId;
    checkOutItem.pet = this.selectedPet;
    checkOutItem.itemName = itemName;
    checkOutItem.unitPrice = unitPrice;
    checkOutItem.quantity = quantity;
    console.log(`getItemDetailFromForm, checkOutItem: ${JSON.stringify(checkOutItem)}`);
    return checkOutItem;
  } // end of getItemDetailFromForm


  updateServiceChargesList() {
    console.log(`updateServiceChargesList`);
    let indexToUpdate = this.selectedServiceCharges.findIndex(item => item.id === this.selectedServiceCharge.id);
    console.log(`updateServiceChargesList, indexToUpdate: ${indexToUpdate}`);
    this.selectedServiceCharges[indexToUpdate] = this.getServiceChargeDetailFromForm();
    console.log(`updateServiceChargesList, selectedServiceCharges: ${JSON.stringify(this.selectedServiceCharges)}`);
  } // end of updateServiceChargesList

  updateCheckOutItemsList() {
    console.log(`updateCheckOutItemsList`);
    let indexToUpdate = this.checkOutItems.findIndex(item => item.itemId === this.selectedCheckOutItem.itemId);
    console.log(`updateCheckOutItemsList, indexToUpdate: ${indexToUpdate}`);
    this.checkOutItems[indexToUpdate] = this.getItemDetailFromForm();
    console.log(`updateCheckOutItemsList, checkOutItems: ${JSON.stringify(this.checkOutItems)}`);
  } // end of updateCheckOutItemsList

  addCheckOutItemList() {
    console.log(`addCheckOutItemList`);
    this.checkOutItems.push(this.getItemDetailFromForm());
    console.log(`addCheckOutItemList, checkOutItems: ${JSON.stringify(this.checkOutItems)}`);
  } // end of addCheckOutItemList

  addServiceChargesList() {
    console.log(`addServiceChargesList`);
    this.selectedServiceCharges.push(this.getServiceChargeDetailFromForm());
    console.log(`addServiceChargesList, selectedServiceCharges: ${JSON.stringify(this.selectedServiceCharges)}`);
  } // end of saveServiceCharge

  createServiceCharge() {

  }

  removeServiceCharge(serviceCharge: ServiceCharge) {

  }

  clearServiceChargeForm() {
    console.log(`clearServiceChargeForm`);
    this.checkOutDetailForm.patchValue({
      itemName: '',
      unitPrice: '',
      quantity: ''
    })
  } // end of clearServiceChargeForm

  saveCheckOutDetail() {
    console.log(`saveCheckOutDetail`);
    this.createCheckOutDetailPayload();
    console.log(`saveCheckOutDetail checkInDetailData: ${this.checkOutDetailData}`);
    if (this.isNew) {
      console.log(`saveCheckOutDetail create check out`);
      this.createCheckOut();
    } else {
      console.log(`saveCheckOutDetail update check out`);
      this.updateCheckOutDetail();
    }
  } // end of saveCheckOutDetail

  patchCheckOutDetailForm(checkOut: CheckOutDetail) {
    this.checkOutDetailForm.patchValue({
      date: this.datepipe.transform(checkOut.date, 'yyyy-MM-dd'),
      discount: checkOut.discount ?? 0,
    });
  } // end of patchCheckInDetailForm

  updateCheckOutDetail() {
    this.isSavingCheckOut = true;
    console.log(`updateCheckOutDetail, checkOutDetailData:${JSON.stringify(this.checkOutDetailData)}`);
    this.petService.updateCheckOut(this.selectedCheckOut.id, this.checkOutDetailData).subscribe({
      next: (response) => {
        this.isSavingCheckOut = false;
        console.log(`updateCheckOutDetail, response: ${JSON.stringify(response)}`);
        this.hideModal(true);
      },
      error: (error) => {
        this.isSavingCheckOut = false;
        console.error(`updateCheckOutDetail, error: ${JSON.stringify(error)}`);
      }
    });
    this.isSavingCheckOut = false;
  } // end of updateCheckOutDetail

  createCheckOut() {
    this.isSavingCheckOut = true;
    console.log(`createCheckOut, checkOutDetailData:${JSON.stringify(this.checkOutDetailData)}`);
    this.petService.createCheckIn(this.checkOutDetailData).subscribe({
      next: (response) => {
        this.isSavingCheckOut = false;
        console.log(`createCheckOut, response: ${JSON.stringify(response)}`);
        this.hideModal(true)
      },
      error: (error) => {
        this.isSavingCheckOut = false;
        console.error(`createCheckOut, error: ${JSON.stringify(error)}`);
        this.hideModal(false)
      }
    });
    this.isSavingCheckOut = false;
  } // end of createCheckOut

  createCheckOutDetailPayload() {
    this.checkOutDetailData.set('date', this.checkOutDetailForm.controls['date'].value);
    this.checkOutDetailData.set('discount', this.checkOutDetailForm.controls['discount'].value);
    // Create check out items payload
    this.createSelectedItemsPayload();
    // Add services ID to payload
    // this.createSelectedServiceChargesPayload();
  } // end of createCheckInDetailPayload

  createSelectedItemsPayload(): void {
    console.log(`createSelectedItemsPayload, checkOutItems: ${JSON.stringify(this.checkOutItems)}`)
    let items: any[] = []
    for (let i = 0; i < this.checkOutItems.length; i++) {
      let item={
        "pet_id": this.checkOutItems[i].pet.id,
        "item_id": this.checkOutItems[i].itemId,
        "item_type": this.checkOutItems[i].itemType,
        "unit_price": this.checkOutItems[i].unitPrice,
        "quantity": this.checkOutItems[i].quantity,
      }
      items.push(item)
      // this.checkOutDetailData.append('items', JSON.stringify(item));
    }
    this.checkOutDetailData.append('items', JSON.stringify(items));
  } // end of createSelectedServicesPayload

  createSelectedServiceChargesPayload(): void {
    for (let i = 0; i < this.selectedServiceCharges.length; i++) {
      let serviceCharge={
        "serviceId": this.selectedServiceCharges[i].service.id,
        "chargeAmount": this.selectedServiceCharges[i].chargeAmount,
        "discount": this.selectedServiceCharges[i].discount,
      }
      this.checkOutDetailData.append('serviceCharges', JSON.stringify(serviceCharge));
    }
  } // end of createSelectedServicesPayload

  hideModal(result: boolean) {
    this.onClose.next(true);
    this.bsModalRef.hide();
  } // end of hideModal

  closeModal() {
    this.hideModal(false);
  } // end of hideModal

  calculateSubtotal() {
    this.subTotalAmount = this.checkOutItems.reduce((sum, item) => {
      // Access the amount property of each object and add it to the sum
      return sum + (item.unitPrice * item.quantity);
    }, 0);
    console.log(`calculateSubtotal, subTotalAmount: ${this.subTotalAmount}`);
    return this.subTotalAmount;
  }

  createInvoice() {
    console.log(`createInvoice`);
    this.isCreatingInvoice = true;
    this.generateCreateInvoicePayload();
    logFormData(this.createInvoiceData);

    this.petService.createInvoice(this.createInvoiceData).subscribe({
      next: (response) => {
        this.isSavingCheckOut = false;
        console.log(`createInvoice, response: ${JSON.stringify(response)}`);
        this.hideModal(true)
      },
      error: (error) => {
        this.isCreatingInvoice = false;
        console.error(`createInvoice, error: ${JSON.stringify(error)}`);
        this.hideModal(false)
      }
    });
    this.isCreatingInvoice = false;
  }

  generateCreateInvoicePayload(): void {
    this.createInvoiceData.append('check_out_id', this.selectedCheckOut.id);
  } // end of generateCreateInvoicePayload

  calculateTotal() {
    let discount = this.checkOutDetailForm.controls['discount'].value;
    this.totalAmount = this.calculateSubtotal() - discount;
  }

  onDiscountChanged(newValue: number){
    console.log(`onDiscountChanged, subTotalAmount: ${this.subTotalAmount}`);
    this.totalAmount = this.subTotalAmount*(1 - newValue/100);
    // this.totalAmount = this.subTotalAmount - newValue;
  }

  checkPermissions(){
    this.hasEditPermission = this.petService.hasPermission('api.change_checkout');
    console.log(`CheckOutDetailComponent, hasEditPermission: ${this.hasEditPermission}`);
    this.hasAddPermission = this.petService.hasPermission('api.add_checkout');
    console.log(`CheckOutDetailComponent, hasAddPermission: ${this.hasAddPermission}`);
    this.hasAddInvoicePermission = this.petService.hasPermission('api.add_invoice');
    console.log(`CheckOutDetailComponent, hasAddInvoicePermission: ${this.hasAddInvoicePermission}`);
  }

  disableForm(){
    if (!this.hasEditPermission) {
      this.checkOutDetailForm.disable();
    }
  }

  getCheckOutInvoice() {
    this.isLoadingCheckOutInvoice = false;
    this.petService.getCheckOutInvoice(this.selectedCheckOut.id).subscribe({
      next: (response) => {
        if (response !=null){
          console.log(`getCheckOutInvoice, response: ${JSON.stringify(response)}`);
          this.checkOutInvoice = this.dataMappingService.mapInvoiceDetailDataToInterface(response);
          console.log(`getCheckOutInvoice, checkOutInvoice: ${JSON.stringify(this.checkOutInvoice)}`);
        }

        this.isLoadingCheckOutInvoice = true;
      },
      error: (error) => {
        this.isLoadingCheckOutInvoice = true;
        console.error(`getCheckOutInvoice, error: ${JSON.stringify(error)}`);
      }
    });
  } // end of getCheckOutInvoice

  isCheckOutInvoiceExist(): boolean {
    console.log(`isCheckOutInvoiceExist, checkOutInvoice: ${JSON.stringify(this.checkOutInvoice)}`);
    console.log(`isCheckOutInvoiceExist, checkOutInvoice: ${this.checkOutInvoice.id !=''}`);
    return (this.checkOutInvoice.id != '');
  }

}
